import actionsPermissionsActionTypes from "../actions/actionsPermissionsActionTypes";


const actionsPermissionsReducer = function actionsPermissionsReducer(state = null, action) {
    switch (action.type) {
        case actionsPermissionsActionTypes.FETCH_PENDING:
            return {
                ...state,
                isError: false,
                isPending: true
            };
        case actionsPermissionsActionTypes.FETCH_SUCCESS:
            return {
                ...state,
                data: action.data,
                isError: false,
                isPending: false
            };
        case actionsPermissionsActionTypes.FETCH_ERROR:
            return {
                ...state,
                data: null,
                isError: true,
                isPending: false
            };
        case actionsPermissionsActionTypes.FETCH_ALL_PENDING:
            return {
                ...state,
                dataAll: null,
                isFetchAllError: false,
                isFetchAllPending: true,
            };
        case actionsPermissionsActionTypes.FETCH_ALL_SUCCESS:
            return {
                ...state,
                dataAll: action.data,
                isFetchAllError: false,
                isFetchAllPending: false,
            };
        case actionsPermissionsActionTypes.FETCH_ALL_ERROR:
            return {
                ...state,
                dataAll: {},
                isFetchAllPending: false,
                isFetchAllError: true,
                message: action.message,
            };
        case actionsPermissionsActionTypes.EDIT_PENDING:
            return {
                ...state,
                isEdit: true,
            };
        case actionsPermissionsActionTypes.EDIT_DONE:
            return {
                ...state,
                isEdit: false,
            };
        default:
            return state;
    }
}


export { actionsPermissionsReducer };